import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import LinearProgress from 'components/LinearProgress'
import Typography from 'components/Typography'

import classes from './ReviewStarBreakdownBar.module.scss'

/** @type {import("./types").default} */
const ReviewStarBreakdownBar = ({ reviews = 0, starRating = 1, percentage = 0 }) => {
  return (
    <div className={clsx('ReviewStarBreakdownBar', classes.container)}>
      <Icon className={classes.star} icon="star" size="16" />
      <Typography variant="tight-sm" className={clsx(classes.numbersColumn, classes.starNumbers)}>
        {starRating}
      </Typography>
      <div className={classes.linearProgressDiv}>
        <LinearProgress value={percentage} />
      </div>
      <Typography variant="tight-sm" className={clsx(classes.numbersColumn, classes.reviewNumbers)}>
        {reviews.toLocaleString()}
      </Typography>
    </div>
  )
}

export default ReviewStarBreakdownBar
